import React, { ComponentProps, MouseEvent } from 'react';
import styled from 'styled-components';
import { LoadingIndicator } from '@spotify-internal/encore-web';
import Primary from 'components/Button/Primary';

const Button = styled(Primary)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Loader = styled(LoadingIndicator)`
  margin-right: 10px;
  fill: currentColor;
  > * {
    fill: currentColor;
  }
`;

type PrimaryWithLoaderTypes = ComponentProps<typeof Primary> & {
  isLoading: boolean;
  disabled?: boolean;
  onClick?: (e: MouseEvent) => void;
};

const PrimaryWithLoader = ({
  children,
  disabled,
  isLoading = false,
  ...rest
}: PrimaryWithLoaderTypes) => (
  <Button {...rest} disabled={disabled || isLoading}>
    {isLoading && <Loader />}
    {/* this span makes this not break on google translate, see https://github.com/facebook/react/issues/11538 */}
    <span>{children}</span>
  </Button>
);

export default PrimaryWithLoader;
